module.exports = {"firstname":"Firstname","lastname":"Lastname","address":"Address","addressExtraInformation":"Address supplement","zipcode":"Zip code","city":"City","email":"Email","mobile":"Mobile","phone":"Phone","website":"Website"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/en/guardian.json
// module id = /4Ev
// module chunks = 1